import {useEffect, useRef} from "react";
import * as THREE from "three";
import {OrbitControls} from "three/examples/jsm/controls/OrbitControls";
import {GLTFLoader} from "three/examples/jsm/loaders/GLTFLoader";


export const About = () => {

    const model = useRef<any>(null)
    const btn = useRef<any>(null)

    useEffect(() => {

        const scene = new THREE.Scene()
        const camera = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight)
        camera.position.z = 10
        camera.position.y = 0


        const renderer = new THREE.WebGLRenderer({alpha: true, antialias: true})
        renderer.setClearColor(0x000000, 0)
        renderer.setSize(1920, 1080)
        renderer.domElement.setAttribute('id', 'model')
        if (model.current.children.length < 1) {
            model.current.appendChild(renderer.domElement)
        }

        const controls = new OrbitControls(camera, renderer.domElement);

        controls.enableZoom = false
        controls.enabled = false
        controls.enableDamping = true
        controls.enablePan = true


        btn.current.addEventListener('click', () => {
            controls.enabled = !controls.enabled
            console.log(camera.position)
            if (!controls.enabled) {
                controls.reset()
            }
        })

        const aLigth = new THREE.AmbientLight(0x404040, 1.2)
        scene.add(aLigth)

        const pLigth = new THREE.PointLight(0xFFFFFF, 1.2)
        pLigth.position.set(0, 10, 20)
        scene.add(pLigth)

        window.addEventListener('resize', onWindowResize, false);

        function onWindowResize() {

            camera.aspect = window.innerWidth / window.innerHeight;
            camera.updateProjectionMatrix();

            renderer.setSize(window.innerWidth, window.innerHeight);

        }

        function resizeRendererToDisplaySize(renderer:any) {
            const canvas = renderer.domElement;
            const width = canvas.clientWidth;
            const height = canvas.clientHeight;
            const needResize = canvas.width !== width || canvas.height !== height;
            if (needResize) {
                renderer.setSize(width, height, false);
            }
            return needResize;
        }

        function render(time:any) {
            time *= 0.001;

            if (resizeRendererToDisplaySize(renderer)) {
                const canvas = renderer.domElement;
                camera.aspect = canvas.clientWidth / canvas.clientHeight;
                camera.updateProjectionMatrix();
            }

            renderer.render(scene, camera);

            requestAnimationFrame(render);
        }

        requestAnimationFrame(render);

        const loader = new GLTFLoader()
        let obj: any = null

        loader.load('./assets/images/3d/react/scene.gltf', function (gltf) {
            obj = gltf
            obj.scene.scale.set(1, 1, 1)

            scene.add(obj.scene)
        })

        let flag = false

        function animate() {
            requestAnimationFrame(animate)

            if (obj) {
                if(obj.scene.rotation.y < 0.8 && !flag) obj.scene.rotation.y += 0.01
                else flag = true
                if(flag){
                    obj.scene.rotation.y -= 0.01
                    if(obj.scene.rotation.y < -0.8) flag = false
                }
            }

            renderer.render(scene, camera)
        }

        animate()
        return () => {
            window.removeEventListener('click', onWindowResize)
        }
    },[])

    return <section className={'about'}>
        <div className="container">
            <div className="about_inner">
                <div className="about_content">
                    <ul>
                        <li>Занимаюсь веб-разработкой 2,5 года.</li>
                        <li>Студент 2 курса <span>ИВТиПТ ЮФУ</span> (Прикладная информатика).</li>
                        <li>В ближайшем будущем планирую более углубленно изучать <span>Vue</span> и <span>Angular</span>, кроме того погрузиться в <span>бэкенд</span>.</li>
                        {/*<li></li>*/}
                        {/*<li></li>*/}
                    </ul>
                    <button ref={btn}></button>
                </div>
                <div ref={model} className="about_model">
                </div>

            </div>
        </div>
    </section>
}